import { createRoadmapWorkspaceSeed, getStoredRoadmapWorkspace, mergeRoadmapWorkspace } from 'mocks/roadmapFinanceMock';

const wait = (ms) => new Promise((resolve) => {
    setTimeout(resolve, ms);
});

const RoadmapFinanceMockService = {
    wait,
    async loadWorkspace(context) {
        await wait(180);
        const seed = createRoadmapWorkspaceSeed(context);
        const persisted = getStoredRoadmapWorkspace();
        return mergeRoadmapWorkspace(seed, persisted);
    },
};

export default RoadmapFinanceMockService;
